import { forwardRef } from "react";
import { useField } from "formik";
import Select from "components/form/Select";

import Priority from "./components/Priority";
import Status from "./components/Status";

const FormikSelect = forwardRef(({ type, name, ...rest }, ref) => {
  const [field, meta] = useField({ name, type });

  return <Select ref={ref} {...rest} {...field} {...meta} isFormik />;
});

FormikSelect.Priority = Priority;
FormikSelect.Status = Status;

export default FormikSelect;
